import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { ManagerService } from "../../utils/services/manager.service";

function ConfirmTransactions({
  show,
  handleClose,
  data = [],
  dictionary,
  paycenters = [],
  routeType = "",
}) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [agent, setAgent] = useState({});

  const confirmData = data?.map((i) => {
    let payload = new Map();
    payload.set("id", i.payableItemId);
    payload.set("payableType", i.payableItemType);
    payload.set("note", i.status);
    payload.set("bankTransferFollowupActionType", "AUTO_CONFIRM_TRANSACTION");
    payload.set("paymentType", i.transactionType);
    const data = Object.fromEntries(payload);
    return { ...data };
  });

  const dataToRoute = data?.map((i) => {
    let payload = new Map();
    payload.set("id", i.payableItemId);
    payload.set("payableType", i.payableItemType);
    payload.set("note", i.status);
    const data = Object.fromEntries(payload);
    return { ...data };
  });

  console.log(dataToRoute, "lop");

  const confirmTransaction = async (payload, password) => {
    setLoading(true);
    try {
      const response = await ManagerService.confirmReceivedPayment(
        payload,
        password
      );
      if (response.data.status === "SUCCESS") {
        handleClose();
        setPassword("");
        toast.success("Transactions confirmed successfully");
        setLoading(false);
      } else {
        toast.error("could not confirm transactions, please try again");
        handleClose();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const routePayableType = async (values, password) => {
    setLoading(true);
    const payload = {
      routeToApiPayCenterId: agent?.id,
      payAbleTypes: [...values],
    };
    try {
      const response = await ManagerService.routePayableType(payload, password);
      if (response.data.status === "SUCCESS") {
        handleClose();
        setPassword("");
        toast.success("Route applied successfully");
        setLoading(false);
      } else {
        toast.error("could not apply routing, please try again");
        handleClose();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  console.log(routeType);

  return (
    <Modal show={show} backdrop="static" keyboard={false} onHide={handleClose}>
      <Modal.Header closeButton={false}>
        <Modal.Title className="fw-bold">Manager Authentication</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          <div className="row row-sm">
            {paycenters?.length > 0 && (
              <div className="col-lg-12 col-md-12 mb-3">
                <label className="pb-2 text-start">
                  Auto route to an Agent/Branch/Partner API for processing
                </label>
                <Select
                  options={paycenters}
                  getOptionLabel={(option) => option?.name}
                  getOptionValue={(option) => option?.id}
                  isClearable={false}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  value={agent}
                  name="pcnFor"
                  onChange={(option) => {
                    setAgent(option);
                  }}
                  className="is-invalid"
                />
              </div>
            )}
            <div className="col-lg-12 col-md-12 mt-2">
              <label className="pb-2 text-start">
                Please enter password for security reasons
              </label>
              <input
                type={"password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password..."
                className="form-control"
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {dictionary ? dictionary["title_cancel"] : "Cancel"}
        </Button>
        {routeType === "manual" ? (
          <Button
            variant="primary"
            onClick={() => {
              routePayableType(dataToRoute, password);
            }}
          >
            {dictionary
              ? dictionary["WO_ROUTE_TRANSACTIONS_1208928746"]
              : "Apply routing"}
            {loading && (
              <>
                &nbsp;
                <i className="fa fa-spinner fa-spin" />
              </>
            )}
          </Button>
        ) : (
          <Button
            variant="primary"
            onClick={() => {
              confirmTransaction(confirmData, password);
            }}
          >
            {dictionary
              ? dictionary["WO_CONFIRM_TRANSACTION_-265684955"]
              : "Confirm Transaction(s)"}
            {loading && (
              <>
                &nbsp;
                <i className="fa fa-spinner fa-spin" />
              </>
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmTransactions;

ConfirmTransactions.defaultProps = {
  handleClose: () => {},
};

ConfirmTransactions.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  routeType: PropTypes.string,
};
